//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 05/08/2024
// Version : 1
// Description : Pantalla principal de estadisticas de reclamos
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { logEventos } from "../../../../services/services";
import { Box, Grid } from "@mui/material";
import Navbar from "../../../Navbar";
import Tabla_motivos from "./Tabla_motivos";
import Grafico_motivos from "./Grafico_motivos";
import Tabla_estados from "./Tabla_estados";
import Grafico_estados from "./Grafico_estados";
import Tabla_instaladores from "./Tabla_instaladores";
import Tabla_categorias from "./Tabla_categorias";
import Tabla_motivos_mantenimiento from "./Tabla_motivos_mantenimiento";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

function Estadisticas_reclamos() {
  const [selectedDate, setSelectedDate] = useState(
    dayjs().subtract(1, "month").startOf("month")
  );

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };
  useEffect(() => {
    logEventos(
      "acceso al menú Area Tecnica",
      "Area Tecnica",
      "Panel de estadísticas de reclamos",
      localStorage.getItem("user")
    );
  }, []);
  return (
    <div>
      <Navbar />
      <Box
        bgcolor="#2B76A6"
        padding={2}
        color="white"
        textAlign="center"
        marginTop={1}
      >
        <Typography
          sx={{
            typography: { xs: "h6", sm: "h5", md: "h4" }, // Tamaño de fuente responsive
          }}
        >
          Panel de estadísticas de reclamos
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <DatePicker
            views={["year"]}
            // label="Año"
            value={selectedDate}
            onChange={handleDateChange}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  marginTop: 2,
                  width: "200px",
                  backgroundColor: "white", // Fondo blanco
                  "& .MuiInputBase-input": {
                    backgroundColor: "white", // Asegura que el input también sea blanco
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </Box>
      <Grid container spacing={2} padding={2} justifyContent={"center"}>
        <Grid
          container
          spacing={2}
          padding={1}
          justifyContent={"left"}
          marginTop={1}
        >
          <Grid item xs={12} sm={6}>
            <Tabla_categorias selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grafico_motivos selectedDate={selectedDate} />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          padding={1}
          justifyContent={"left"}
          marginTop={1}
        >
          <Grid item xs={12} sm={12}>
            <Tabla_motivos selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Tabla_motivos_mantenimiento selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Tabla_estados selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Grafico_estados selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Tabla_instaladores selectedDate={selectedDate} />
          </Grid>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
    </div>
  );
}

export default Estadisticas_reclamos;
